<mat-spinner diameter="200"></mat-spinner>
<div class="logo">
    <img src="assets/images/logo-blue-horizontal.svg" />
</div>
